import { useMemo } from 'react'

import { CheckLine } from 'lucide-react'

import { cn } from '@fortem-monorepo/js-utilities'
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@fortem-monorepo/react-ui'

import { usePnlContext } from '@/pages/operations/pnl-attributions/context'
import { usePnlAttributionsActions } from '@/pages/operations/pnl-attributions/pnl-attribution-actions'
import { useInternalUser } from '@/react-query/queries/account'

export interface PublishAttributionsButtonProps {}

export const PublishAttributionsButton: React.FC<PublishAttributionsButtonProps> = ({}) => {
  const { params, selectedBatchState } = usePnlContext()
  const { openPublishAttributions } = usePnlAttributionsActions()
  const { internalUser } = useInternalUser()

  const actioned_by_id = selectedBatchState?.actioned_by_id
  const batch_id = selectedBatchState?.batch_id

  const disabled = internalUser?.user_id === actioned_by_id

  const button = useMemo(() => {
    return (
      <Button
        disabled={disabled}
        className={cn({
          'pointer-events-none': disabled,
        })}
        size="sm"
        variant="outline"
        onClick={() => {
          if (batch_id) {
            openPublishAttributions({
              ...params,
              batch_id,
            })
          }
        }}
      >
        Publish <CheckLine />
      </Button>
    )
  }, [])

  if (!disabled) {
    return button
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={'inline-flex'} tabIndex={0}>
          {button}
        </span>
      </TooltipTrigger>
      <TooltipContent>You cannot publish these attributions as you were the user who staged them.</TooltipContent>
    </Tooltip>
  )
}
